import React from 'react';
type propsType = {
    className?: string;
}
const PencilIcon = (props: propsType) => {
    const className = `icon-15 ${props.className || ''}`;
    return <svg className={className} focusable="false" viewBox="0 0 174.8 175.2"  aria-hidden="true">
        <path fill="#30a9b8" d="M93.1,35.9c2.9,3,5.8,5.8,9.1,9.2c-0.6,0.3-1.3,0.6-1.8,1.1c-23.6,23.5-47.1,47-70.6,70.6c-0.8,0.8-1.6,2-1.9,3.2
	c-2.8,9.4-5.6,18.8-8.4,28.3c-0.3,1-0.2,1.7,0.6,2.4c1.5,1.4,2.9,3,4.4,4.3c0.5,0.4,1.5,0.7,2.1,0.6c9.3-2.7,18.7-5.4,28-8.2
	c0.9-0.3,1.8-1,2.5-1.7c23.8-23.7,47.6-47.5,71.4-71.3c0.5-0.5,0.9-1.1,1.2-1.5c3.4,3.5,6.7,6.7,10.3,10.4c-0.3,0.2-1,0.5-1.5,1
	c-23.6,23.3-47.2,46.6-70.6,70.1c-3,3-6.2,4.8-10.2,6c-16,4.6-32,9.3-48,14c-3.7,1.1-6.5,0.2-8.3-2.7c-1.2-1.8-1.2-3.8-0.6-5.8
	C5.7,148.4,10.8,131,16,113.6c0.4-1.3,1.1-2.6,2.1-3.5c24.6-24.5,49.3-48.9,74-73.3C92.4,36.5,92.7,36.2,93.1,35.9z"/>
        <path fill="#30a9b8" d="M109.3,52.4c4.1,4.1,8.2,8.1,12.1,12C96.7,89.2,71.9,114,47,139c-0.5-2.8-1-5.5-1.3-8.2c-0.1-1.2-0.6-1.6-1.8-1.9
	c-3-0.6-6-1.3-8.9-2C59.8,102.1,84.6,77.2,109.3,52.4z"/>
        <path fill="#30a9b8" d="M118.3,11.6c3.1-2.8,6-6.2,9.6-8.6c6.3-4.2,13.9-3.1,19.6,2.5c7.4,7.3,14.8,14.6,22.1,22.1c6.7,6.9,6.5,16.1-0.2,23
	c-2,2.1-4.2,4.1-6.1,6C148.4,41.6,133.5,26.7,118.3,11.6z"/>
        <path fill="#30a9b8" d="M157.2,65.4c-3.3,3.1-6.8,6.4-10.2,9.6c-15.6-15.6-31.2-31.2-46.8-46.8c3.4-3.1,6.9-6.4,10.2-9.6
	C126,34.2,141.5,49.7,157.2,65.4z"/>
    </svg>
}
export default PencilIcon;
